import { render, staticRenderFns } from "./uploadFile2.vue?vue&type=template&id=148f759e&scoped=true&"
import script from "./uploadFile2.vue?vue&type=script&lang=js&"
export * from "./uploadFile2.vue?vue&type=script&lang=js&"
import style0 from "./uploadFile2.vue?vue&type=style&index=0&id=148f759e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148f759e",
  null
  
)

export default component.exports